import React from 'react';
import Grid from '@mui/material/Grid2'
import { Modal, Fade, Paper, Button, Backdrop, Divider, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'
import useTranslation from '../../../hooks/useTranslation'

const styles = {
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    width: { xs: '95%', sm: '70%', md: '60%', lg: '50%' },
    boxShadow: 24
  },
  container: {
    padding: '2%'
  }
}
const CustomModal = (props) => {
  const { modalBody, title, modalState, handleModalState } = props;
  const { t } = useTranslation()

  return (
    <Modal
      open={modalState}
      onClose={() => handleModalState(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={modalState}>
        <Paper sx={styles.modal}>
          <Grid container alignItems="center">
            <Grid size={11} sx={{paddingLeft: '2%'}}>
              <h3>{title}</h3>
            </Grid>
            <Grid size={1}>
              <IconButton sx={{float: 'right'}} onClick={() => handleModalState(false)}><CloseIcon /></IconButton>
            </Grid>
            <Divider width='100%' />
            <Grid size={12}>
              {modalBody}
            </Grid>
            <Divider width="100%" />
            <Grid sx={styles.container} size={12} textAlign="end">
              <Button variant='outlined' onClick={() => handleModalState(false)}>{t('labels.close')}</Button>
            </Grid>
          </Grid>
        </Paper>
      </Fade>
    </Modal>
  );
}

export default CustomModal;